import React, { useState } from "react";
import logo from "../../../Assets/AppComponent/Qpms/White_logo.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import "../../../StyleSheet/MainComponent/Verifycation/Verification.scss";
import Text from "../../AppComponent/InputFields/Text";
import OTP from "../../AppComponent/InputFields/OTP/OTP";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import { useSelector } from "react-redux";
const Verification = () => {
  const EnglishData = data;
  const HindiData = hindiDatas;
  const State = useSelector((state) => state);
  return (
    <>
          <div className="qpms-loginpage ">

      {/* <div className="uds-Verications"> */}
        <div className="  Conatiningpart">
          <div className=" Welcomepart">
            {/* <div className="Toppart">
              <img className="desingimg" src={toppart} />
            </div> */}
            <div className="bottompart">
              <div className="leftSidepart">
                <div className="Logo">
                  <img className="logoUds" src={logo} />
                </div>
                {/* <div className='Content'>
                                    <h1>WELCOME</h1>
                                  
                                </div> */}

                {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.Welcome.map((item) => (
                      <div className="   Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {hindiDatas.LeftSide.Welcome.map((item) => (
                      <div className="   Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                )}

                {/* <p>Reset Your Password</p> */}

                {/* {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.Content.ContentPassword.map(
                      (item) => (
                        <p>{item.para1}</p>
                      )
                    )}
                  </>
                ) : (
                  <>
                    {hindiDatas.LeftSide.Content.ContentPassword.map((item) => (
                      <p>{item.para1}</p>
                    ))}
                  </>
                )} */}

                {/* <div className='para'>                  
                                 <p>Lorem Ipsum is simply dummy text of the printing and typesetting   <br /> industry.

                                    Lorem Ipsum has been the industry's standard dummy text ever </p>
                                </div> */}

                {/* {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.Content2.map((item) => (
                      <div className="para">
                        <p>{item.para2}</p>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {hindiDatas.LeftSide.Content2.map((item) => (
                      <div className="para">
                        <p>{item.para2}</p>
                      </div>
                    ))}
                  </>
                )} */}


                {/* --------Details-------------------- */}
                {/* <div className="Details">

                  {State.Language.Language == "English" ? (
                    <>
                      {EnglishData.LeftSide.Details.Details3.map((item) => (
                        <p key={item.id}>{item.Details}</p>
                      ))}
                    </>
                  ) : (
                    <>
                      {hindiDatas.LeftSide.Details.Details3.map((item) => (
                        <p key={item.id}>{item.Details}</p>
                      ))}
                    </>
                  )}
                  <div className="Arrow">
                    <img src={Arrow} />
                  </div>
                </div> */}


              </div>
            </div>
          </div>
          <div className="loginpart">
            <div className="Loginwrapped">
              <div className="UdsVerify">
                {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.Content.VerifiContent.Header.map(
                      (item) => (
                        <h4 className="heading">{item.Name}</h4>
                      )
                    )}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.Content.VerifiContent.Header.map(
                      (item) => (
                        <h4 className="heading">{item.Name}</h4>
                      )
                    )}
                  </>
                )}

                <div className="Input-Inner">
                  {/* --------Otp---Verify-------------------------- */}
                  <div className="Otp-Verify">
                    <OTP />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Verification;
